import React, { useState, useEffect, useContext } from "react";
import AuthServices from "../../services/AuthServices";
import { PDFDocument, rgb, degrees } from "pdf-lib";
import DashboardLayout from "../common/DashboardLayout";
import { useParams } from "react-router-dom";
import { format } from 'date-fns';
import AuthContext from "../../context/AuthContext";

// React-PDF setup
import { Document, Page, pdfjs } from 'react-pdf';
// Set worker locally to avoid CDN/CORS issues
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;

const AddWatermark = () => {
  const [pdfSrc, setPdfSrc] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expiredate, setExpiredate] = useState(null);
  const { userid } = useParams();
  const { userrole } = useContext(AuthContext);

  // PDF Rendering State
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  console.log(userid, "userid--")
  // Use the PDF from public folder - rename to avoid space issues
  const pdfUrl = process.env.PUBLIC_URL
    ? `${process.env.PUBLIC_URL}/Emergency_Management_Protocol.pdf`
    : '/Emergency_Management_Protocol.pdf';

  function onDocumentLoadSuccess({ numPages }) {
    console.log("[DEBUG] PDF Loaded Successfully. Pages:", numPages);
    setNumPages(numPages);
  }

  function onDocumentLoadError(error) {
    console.error("[DEBUG] PDF Load Failed:", error);
    setError(error.message);
  }

  const addWatermark = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(pdfUrl);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
      }

      const existingPdfBytes = await response.arrayBuffer();

      // Check if we got HTML back (SPA fallback) instead of PDF
      const firstBytes = new Uint8Array(existingPdfBytes.slice(0, 5));
      const firstString = new TextDecoder().decode(firstBytes);
      if (firstString.includes('<') || firstString.includes('<!')) {
        throw new Error("Server returned HTML instead of PDF. File may be missing.");
      }

      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const pages = pdfDoc.getPages();
      const { width, height } = pages[0].getSize();
      const watermarkText = `Expires ${expiredate}`;

      pages.forEach((page) => {
        page.drawText(watermarkText, {
          x: width / 4,
          y: height / 3,
          size: 60,
          color: rgb(0.9, 0.9, 0.9),
          rotate: degrees(45),
          opacity: 0.5,
        });
      });

      const pdfBytes = await pdfDoc.save();
      const blob = new Blob([pdfBytes], { type: "application/pdf" });

      if (pdfSrc) {
        URL.revokeObjectURL(pdfSrc);
      }

      setPdfSrc(URL.createObjectURL(blob));
    } catch (err) {
      console.error("Error adding watermark:", err);
      const errorMessage = err.message || "Failed to process PDF";
      setError(`Failed to load PDF: ${errorMessage}. Please ensure the file exists at: ${pdfUrl}`);
    } finally {
      setLoading(false);
    }
  };

  /* DEBUG MODE: Bypass watermarking to test raw PDF rendering */
  /* DEBUG MODE: Bypass watermarking to test raw PDF rendering */
  // useEffect(() => {
  //   if (pdfUrl) {
  //     console.log("[DEBUG] Loading Raw PDF:", pdfUrl);
  //     setPdfSrc(pdfUrl); // Direct load, no watermark
  //     setLoading(false);
  //   }
  // }, [pdfUrl]);

  // Original Watermark Logic (Restored)
  useEffect(() => {
    if (pdfUrl && expiredate) {
      addWatermark();
    }
  }, [expiredate, pdfUrl]); // Added pdfUrl dependency for safety

  useEffect(() => {
    const viewCertificates = async () => {
      try {
        const response = await AuthServices.viewCertificateByUserId({ userid: userid, type: 'Emergency Managment Protocol' });

        if (!response || !response.certificatedata) {
          throw new Error("Certificate data not found for this user.");
        }

        const expirationDate = new Date(response.certificatedata.expirationDate);
        const formattedDate = format(expirationDate, "MM dd yyyy");
        setExpiredate(formattedDate);
        console.log(formattedDate, 'get data');

      } catch (error) {
        console.error("Error fetching certificates:", error);
        setError("Could not retrieve certificate details. Please try again.");
        setLoading(false);
      }
    };

    viewCertificates();
  }, []);

  // Get user type for proper role handling
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const userType = user?.type || null;

  // Robust Role Retrieval: Context -> LocalStorage(userrole) -> LocalStorage(user.role)
  let rawRole = userrole;
  let roleSource = "Context";

  if (!rawRole) {
    rawRole = localStorage.getItem("userrole");
    roleSource = "LocalStorage(userrole)";
  }

  if (!rawRole && user?.role) {
    rawRole = user.role;
    roleSource = "LocalStorage(user.role)";
  }

  const role = rawRole ? String(rawRole) : null;

  console.log('[StaticCertificate] Layout Params:', {
    userType,
    rawRole,
    role,
    roleSource,
    userId: userid,
    userDetails: user
  });

  return (
    <DashboardLayout
      role={role}
      userType={userType}
      layoutType="topnav"
      showBreadcrumbs={true}
    >
      <div className="container">
        {loading && <p className="text-center py-4">Processing PDF and adding secure watermark...</p>}
        {error && (
          <div style={{ color: "red", padding: "20px", background: "#ffe6e6", borderRadius: "5px", marginBottom: "20px" }}>
            <strong>Error:</strong> {error}
            <br />
            <small>Make sure the PDF file exists at: {pdfUrl}</small>
          </div>
        )}

        {pdfSrc && !loading && (
          <>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginBottom: '20px' }}>
              <a href={pdfSrc} target="_blank" rel="noopener noreferrer">
                <button
                  style={{
                    padding: "10px 20px",
                    fontSize: "16px",
                    backgroundColor: "#17a2b8",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                    width: '200px'
                  }}
                >
                  Open in New Tab
                </button>
              </a>
              <a href={pdfSrc} download="EmergencyManagementProtocol.pdf">
                <button
                  style={{
                    padding: "10px 20px",
                    fontSize: "16px",
                    backgroundColor: "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                    width: '200px'
                  }}
                >
                  Download PDF
                </button>
              </a>
            </div>

            <div className="d-flex justify-content-center bg-light p-4 border rounded" style={{ minHeight: '600px' }}>
              <Document
                file={pdfSrc}
                onLoadSuccess={onDocumentLoadSuccess}
                onLoadError={onDocumentLoadError}
                loading={<div className="text-center">Loading PDF renderer...</div>}
                error={<div className="text-danger">Failed to render PDF inline. Please use the &quot;Open in New Tab&quot; button.</div>}
              >
                {/* Certificates are usually single page, but render all just in case */}
                {Array.from(new Array(numPages || 0), (el, index) => (
                  <Page
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                    scale={1.2}
                    className="mb-4 shadow-sm"
                  />
                ))}
              </Document>
            </div>
          </>
        )}
      </div>
    </DashboardLayout>
  );
};

export default AddWatermark;
